<template>
    <div class="new-year-logo-wrapper">
        <div v-if="isNewYearPeriod" class="logo-flip-container">
            <div class="logo-flip-inner">
                <div class="logo-flip-front">
                    <slot></slot>
                </div>
                <div class="logo-flip-back">
                    <svg class="christmas-tree" viewBox="0 0 100 120" width="32" height="38">
                        <!-- Ağaç gövdesi -->
                        <rect x="42" y="95" width="16" height="20" fill="#8B4513"/>
                        <!-- Ağaç katmanları -->
                        <polygon points="50,5 20,40 35,40 15,65 30,65 10,95 90,95 70,65 85,65 65,40 80,40" fill="#228B22"/>
                        <!-- Yıldız -->
                        <polygon points="50,0 52,8 60,8 54,13 56,21 50,16 44,21 46,13 40,8 48,8" fill="#FFD700"/>
                        <!-- Süsler -->
                        <circle cx="35" cy="50" r="4" fill="#FF0000"/>
                        <circle cx="65" cy="55" r="4" fill="#FFD700"/>
                        <circle cx="45" cy="70" r="4" fill="#1E90FF"/>
                        <circle cx="58" cy="75" r="4" fill="#FF69B4"/>
                        <circle cx="30" cy="80" r="4" fill="#FFD700"/>
                        <circle cx="70" cy="85" r="4" fill="#FF0000"/>
                        <circle cx="50" cy="45" r="3" fill="#00CED1"/>
                        <circle cx="40" cy="88" r="3" fill="#9400D3"/>
                        <circle cx="60" cy="90" r="3" fill="#32CD32"/>
                        <!-- Işık süsleri -->
                        <circle cx="28" cy="60" r="2" fill="#FFFF00" class="tree-light light-1"/>
                        <circle cx="72" cy="65" r="2" fill="#FFFF00" class="tree-light light-2"/>
                        <circle cx="25" cy="85" r="2" fill="#FFFF00" class="tree-light light-3"/>
                        <circle cx="75" cy="80" r="2" fill="#FFFF00" class="tree-light light-4"/>
                        <circle cx="50" cy="60" r="2" fill="#FFFF00" class="tree-light light-5"/>
                    </svg>
                </div>
            </div>
        </div>
        <slot v-else></slot>
    </div>
</template>

<script>
export default {
    name: "NewYearLogoFlip",
    computed: {
        isNewYearPeriod() {
            const now = new Date();
            const month = now.getMonth();
            const day = now.getDate();
            return (month === 11 && day === 31) || (month === 0 && day === 1);
        },
    },
};
</script>

<style scoped>
.new-year-logo-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
}

.logo-flip-container {
    perspective: 1000px;
    width: 100px;
    height: 40px;
}

.logo-flip-inner {
    position: relative;
    width: 100%;
    height: 100%;
    transform-style: preserve-3d;
    animation: logoFlip 30s infinite;
}

.logo-flip-front,
.logo-flip-back {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}

.logo-flip-back {
    transform: rotateY(180deg);
}

/* 30sn döngü: 25sn logo (0-83.33%), 5sn ağaç (83.33%-100%) */
@keyframes logoFlip {
    0% {
        transform: rotateY(0deg);
    }
    82.5% {
        transform: rotateY(0deg);
    }
    83.33% {
        transform: rotateY(180deg);
    }
    99.5% {
        transform: rotateY(180deg);
    }
    100% {
        transform: rotateY(360deg);
    }
}

/* Çam ağacı ışık animasyonu */
.christmas-tree .tree-light {
    animation: treeLights 1s ease-in-out infinite;
}

.christmas-tree .light-1 { animation-delay: 0s; }
.christmas-tree .light-2 { animation-delay: 0.2s; }
.christmas-tree .light-3 { animation-delay: 0.4s; }
.christmas-tree .light-4 { animation-delay: 0.6s; }
.christmas-tree .light-5 { animation-delay: 0.8s; }

@keyframes treeLights {
    0%, 100% {
        opacity: 1;
        fill: #FFFF00;
    }
    50% {
        opacity: 0.3;
        fill: #FFA500;
    }
}
</style>
